import { useQuery, useMutation } from '@apollo/client';
import { useNotifications } from '@sixfold/common-ui';
import { useParams } from 'react-router';

import {
  CompanyAssetsQuery,
  CompanyAssetsQueryVariables,
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CompanyAssetsView, CompanyAssetsViewProps } from '../components/company_assets';
import { companyAssetsQuery, updateCompanyMutation } from '../graphql';

class LoadingContainer extends Loader<CompanyAssetsQuery, CompanyAssetsViewProps, CompanyAssetsQueryVariables> {}

export const CompanyAssetsContainer = () => {
  const { company_id } = useParams() as { company_id: string };
  const notify = useNotifications();
  const result = useQuery<CompanyAssetsQuery, CompanyAssetsQueryVariables>(companyAssetsQuery, {
    variables: {
      company_id,
    },
  });
  const [updateCompany] = useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(updateCompanyMutation);

  return (
    <LoadingContainer
      result={result}
      mapData={({ data }) => ({
        data: { company: data.company ?? null },
        onAssetUpdate: async (file, asset) => {
          await updateCompany({
            variables: {
              company_id,
              input: {
                ...(asset === 'consignee_background' ? { consigneeBackground: { upload: file } } : {}),
                ...(asset === 'consignee_logo' ? { consigneeLogo: { upload: file } } : {}),
              },
            },
          });
          notify.success({ title: 'Assets updated' });
          return true;
        },
      })}>
      {({ data, onAssetUpdate }) => <CompanyAssetsView data={data} onAssetUpdate={onAssetUpdate} />}
    </LoadingContainer>
  );
};
